<template>
  <OrganizationDashboard v-if="organizationDomain === null" />
  <HubDashboard v-else />
</template>

<script setup lang="ts">
import { definePageMeta, navigateTo, useOrganizationDomain } from '#imports';
import { useNuxtApp } from 'nuxt/app';
import { useAuthUserStore } from '~/store/auth-user';
import { useOrganizationStore } from '~/store/organization';
import { defineNuxtRouteMiddleware, callWithNuxt, RouteMiddleware } from '#app';
import { OrganizationDashboard } from '~/pages/_components/organization-dashboard';
import { HubDashboard } from '~/pages/_components/hub-dashboard';

definePageMeta({
  // eslint-disable-next-line require-await
  middleware: defineNuxtRouteMiddleware(async () => {
    const nuxtApp = useNuxtApp();
    const authUserStore = useAuthUserStore();
    const organizationStore = useOrganizationStore();

    if (!authUserStore.isLoggedIn && !organizationStore.isPublic) {
      return callWithNuxt(nuxtApp, navigateTo, ['/auth/login']);
    }
  }),
});

const organizationDomain = useOrganizationDomain();
</script>
